__turbopack_context__.v({
  "blue": "AIServiceCard-module-scss-module__KUTiGG__blue",
  "card": "AIServiceCard-module-scss-module__KUTiGG__card",
  "cardTitle": "AIServiceCard-module-scss-module__KUTiGG__cardTitle",
  "green": "AIServiceCard-module-scss-module__KUTiGG__green",
  "iconWrapper": "AIServiceCard-module-scss-module__KUTiGG__iconWrapper",
  "listWrapper": "AIServiceCard-module-scss-module__KUTiGG__listWrapper",
  "orange": "AIServiceCard-module-scss-module__KUTiGG__orange",
  "pink": "AIServiceCard-module-scss-module__KUTiGG__pink",
  "readMore": "AIServiceCard-module-scss-module__KUTiGG__readMore",
});
